// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"396":"45b69582","733":"5401fb67","755":"cf5a0024"}[chunkId] + ".chunk.css";
};